import React from 'react';
import { CtaButton } from './CtaButton';
import { RatingProof } from './RatingProof';
import { Waves } from './Waves';
import { heroImage } from '../data/heroImage';
const chips = [{
  label: '6 volumes',
  dot: 'bg-sage'
}, {
  label: '300 pages',
  dot: 'bg-teal'
}, {
  label: '24+ class plans',
  dot: 'bg-peach'
}, {
  label: '17 routines in 8-counts',
  dot: 'bg-sky'
}, {
  label: '5 bonuses',
  dot: 'bg-rose'
}];
const micro = ['Instant PDF download', '7-day money-back guarantee', 'No subscription'];
export function Hero() {
  return <section className="stage-smoke relative w-full overflow-hidden text-white" data-id="element-115" data-mp="xb5r1d2hkpv7">
      <p aria-hidden="true" className="pointer-events-none absolute inset-x-0 top-4 select-none text-center font-poster text-[26vw] uppercase leading-none text-white/[0.07] lg:top-8 lg:text-[270px]" data-id="element-116" data-mp="sa02lrfuzorh">
        Bollywood
      </p>

      <div className="relative mx-auto max-w-6xl px-5 pt-12 sm:pt-16" data-id="element-117" data-mp="382p73hcojln9">
        <div className="grid items-center gap-8 lg:grid-cols-[1fr_1.15fr] lg:gap-6" data-id="element-118" data-mp="384jur3fc5rv1">
          <div data-id="element-119" data-mp="3j9ahvf8c4u67">
            <p className="text-sm font-semibold text-peach" data-id="element-120" data-mp="3j6obvk13emq3">
              Bollywood Class Ready · for Bollywood dance instructors
            </p>
            <h1 className="mt-4 font-display text-[40px] leading-[1.04] sm:text-[58px] md:text-[64px]" data-id="element-121" data-mp="39b4l1c1dye87">
              A full year of Bollywood classes, ready to teach.{' '}
              <span className="text-peach" data-id="element-122" data-mp="30ib0az366mmy">No more blank page on Sunday night.</span>
            </h1>
            <p className="mt-5 max-w-xl text-base text-white/80 sm:text-lg" data-id="element-123" data-mp="358hncui19z33">
              Six volumes of done-for-you classes for kids, beginners, adults
              and recreational groups. Every step and routine written in clear
              8-count blocks, with the cues, the levels and the timing already
              done. Open it, pick a class, teach it.
            </p>
            <div className="mt-6 lg:hidden" data-id="element-124" data-mp="2hljb690y5daz">
              <CtaButton data-id="element-125" data-mp="2ljpch1j0n0oi">Get Bollywood Class Ready</CtaButton>
              <div className="mt-4 flex justify-center" data-id="element-126" data-mp="s21kmih80q35">
                <RatingProof tone="dark" data-id="element-127" data-mp="s3mb9x0ezovq" />
              </div>
            </div>
            <ul className="mt-6 flex flex-wrap gap-2" data-id="element-128" data-mp="na9z4mcx9ajv">
              {chips.map(chip => <li key={chip.label} className="flex items-center gap-2 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold text-white/90 ring-1 ring-white/15" data-id="element-129" data-mp="id9v0gzmuhve">
                  <span className={`h-2 w-2 rounded-full ${chip.dot}`} data-id="element-130" data-mp="1b0du65c1o1z9" />
                  {chip.label}
                </li>)}
            </ul>
          </div>

          <img src={heroImage} alt="Bollywood Class Ready: six spiral-bound volumes, from Teaching Engine to Showcases Year, in a dance studio" width={2048} height={1360} className="w-full rounded-3xl object-cover shadow-cover ring-1 ring-white/10" data-id="element-131" data-mp="111y9ak3m1oy7" />
        </div>

        <div className="mt-8 flex flex-col items-center" data-id="element-132" data-mp="3hq266xcxa69u">
          <div className="hidden w-full max-w-md lg:block" data-id="element-133" data-mp="1xa431cdmkgik">
            <CtaButton data-id="element-134" data-mp="1x7hvhcqqi10c">Get Bollywood Class Ready</CtaButton>
          </div>
          <div className="mt-5 hidden lg:block" data-id="element-135" data-mp="21b64lzv0l4np">
            <RatingProof tone="dark" data-id="element-136" data-mp="269hbq2txd128" />
          </div>
          <p className="mt-4 max-w-md text-center text-sm text-white/75" data-id="element-137" data-mp="268oblkph19t2">
            Written for Bollywood instructors teaching in studios, gyms,
            schools, community centers and online. 30, 45 or 60-minute
            classes. One payment, yours to keep.
          </p>
          <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-white/65" data-id="element-138" data-mp="2kxc6dorhtfhy">
            {micro.map(item => <li key={item} className="flex items-center gap-2" data-id="element-139" data-mp="2tzlgidiun6ut">
                <span className="h-1.5 w-1.5 rounded-full bg-peach" data-id="element-140" data-mp="2tz20j2cresjf" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
      <Waves to="#FFFFFF" className="relative mt-10" data-id="element-141" data-mp="zkr8ym4s5k9y" />
    </section>;
}